import { render } from "./tw-cell-edit.vue?vue&type=template&id=3e23e2bc"
import script from "./tw-cell-edit.vue?vue&type=script&lang=js"
export * from "./tw-cell-edit.vue?vue&type=script&lang=js"
script.render = render

export default script